module.exports = __webpack_public_path__ + "src/img/zalando/feature-large.fb16d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/feature-large.jpg
// module id = 260
// module chunks = 0